/**
 * OrbDocTutorialsIntermediateCrossOrbitalAROrbDocTutorialsIntermediateCrossOrbitalARPage
 *
 * Page component for OrbDocTutorialsIntermediateCrossOrbitalAROrbDocTutorialsIntermediateCrossOrbitalARPage
 * Path: /ar/docs/tutorials/intermediate/cross-orbital
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocTutorialsIntermediateCrossOrbitalARDocScreenView as __OrbDocTutorialsIntermediateCrossOrbitalARDocScreenView } from '@/components/traits/OrbDocTutorialsIntermediateCrossOrbitalARDocScreenView';
import { OrbDocTutorialsIntermediateCrossOrbitalARDocAnalyticsView as __OrbDocTutorialsIntermediateCrossOrbitalARDocAnalyticsView } from '@/components/traits/OrbDocTutorialsIntermediateCrossOrbitalARDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocTutorialsIntermediateCrossOrbitalAROrbDocTutorialsIntermediateCrossOrbitalARPageProps {
  // Add any page-level props here
}

export function OrbDocTutorialsIntermediateCrossOrbitalAROrbDocTutorialsIntermediateCrossOrbitalARPage(_props: OrbDocTutorialsIntermediateCrossOrbitalAROrbDocTutorialsIntermediateCrossOrbitalARPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"الأحداث بين المداريّات","description":"صِل بين مداريّين بحدث خارجي واستماع مؤهَّل، دون أن يمد أيٌّ منهما يده إلى الآخر.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/tutorials/intermediate/cross-orbital"},{"locale":"ar","path":"/ar/docs/tutorials/intermediate/cross-orbital"},{"locale":"sl","path":"/sl/docs/tutorials/intermediate/cross-orbital"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocTutorialsIntermediateCrossOrbitalARDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocTutorialsIntermediateCrossOrbitalARDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocTutorialsIntermediateCrossOrbitalAROrbDocTutorialsIntermediateCrossOrbitalARPage;
